import React, {useState, useEffect} from "react";
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {getFacility, getGWDeviceCtl} from "../../api/apiClient";
// import ComboInputPeriod from "../../components/inputs/ComboInputPeriod";
import ComboFclty from "../../components/inputs/ComboFclty";
import ComboCtlType from "../../components/inputs/ComboCtlType";
import ComboInputPeriodV2 from "../inputs/ComboInputPeriodV2";

const DateFacilityFireSearchBox = ({
                                     searchParam,
                                     setSearchParam,
                                     updateList,
                                     setCurrentPage
                                   }) => {

  const onChangeStartDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, startDate: date};
    });
  };

  const onChangeStartHour = (value) => {
    setSearchParam((prev) => {
      return {...prev, startHour: value};
    });
  };

  const onChangeEndDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, endDate: date};
    });
  };

  const onChangeEndHour = (value) => {
    setSearchParam((prev) => {
      return {...prev, endHour: value};
    });
  };

  const onChangeFacilityName = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchFcltyNo: e.target.value};
    });
  };

  const onChangeControlType = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchCtrlTy: e.target.value};
    });
  };

  /* 시설 목록 */
  const [stFcltyList, setFcltyList] = useState([]);
  /* 시설 목록 갱신 */
  const updateFacilityList = () => {
    getFacility('')
        .then((res) => {
              setFcltyList(res.data.data.list);
            }
        );
  };

  /* 제어유형 목록 */
  const [stCtrlTyList, setFcltyCtrlTyList] = useState([]);
  /* 제어유형 목록 갱신 */
  const updateCtrlTyList = () => {
    getGWDeviceCtl()
        .then((res) => {
              setFcltyCtrlTyList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateFacilityList();
    updateCtrlTyList();
  }, []);

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-start"}>
            <Col md={12}>
              <Row className={"justify-content-start"}>
                <Col md={10}>
                  <Row className={"gy-2"}>

                    {/*<Col md={9} className={"mb-3"}>*/}
                    <Col xxl={6} xl={12} lg={12} md={12}>
                      <ComboInputPeriodV2
                          propSearchParam={searchParam}
                          propOnChangeStart={onChangeStartDate}
                          propOnChangeEnd={onChangeEndDate}
                          propOnChangeStartHour={onChangeStartHour}
                          propOnChangeEndHour={onChangeEndHour}
                          // propLabelSize={1}
                          // propInputSize={5}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={6}>
                      <ComboFclty
                          propOnChange={onChangeFacilityName}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={6}>
                      <ComboCtlType propType={'1'}
                                    propOnChange={onChangeControlType}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={2} className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                  <Button
                      type="submit"
                      className={"search-btn"}
                      style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </>
  )
      ;
};

export default DateFacilityFireSearchBox;
